// removed by extract-text-webpack-plugin
module.exports = {"ellipsis":"antd-pro-ellipsis","lines":"antd-pro-lines","shadow":"antd-pro-shadow","linesCover":"antd-pro-linesCover"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Ellipsis/index.less
// module id = 370
// module chunks = 0 1